import { el } from './dom.js';

/**
 * Notifiche temporanee non bloccanti (conferme, avvisi).
 */

/**
 * @param {HTMLElement|null} container
 * @param {string} message
 * @param {object} [options]
 * @param {'info'|'success'|'error'} [options.variant='info']
 * @param {number} [options.duration=2600] durata in ms
 * @returns {HTMLElement|null} il nodo creato
 */
export function showToast(container, message, { variant = 'info', duration = 2600 } = {}) {
  if (!container || !message) return null;

  const toast = el('div', { class: `toast toast--${variant}`, role: 'status', text: message });
  container.append(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(8px)';
    setTimeout(() => toast.remove(), 220);
  }, duration);

  return toast;
}
